<template>
	<el-tabs id="userinfoList" value="first" type="border-card">
		<el-tab-pane name="first" :label="$t('projectInfo')">
			<el-row>
				<el-col :xs="24">
          <el-form :model="projectForm" :rules="rules" ref="projectForm" label-width="200px">
					  <el-card >
							<el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('businessCategory1')" prop="businessCategory">
                    <el-select v-model="projectForm.businessCategory" disabled @change="selectBusinessCategory">
											<el-option v-for="item in BusinessCategoryList" :key="item.sysDesc" :label="item.sysValue" :value="item.sysDesc"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('projectType1')" prop="projectType" >
										<el-select v-model="projectForm.projectType" disabled>
											<el-option v-for="item in ProjectTypeList" :key="item.sysDesc" :label="item.sysValue" :value="item.sysDesc"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
              </el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('country1')" prop="country" >
                    <el-select v-model="projectForm.country" :disabled="editCountry" clearable filterable>
											<el-option v-for="item in CountryList" :key="item.sysValue" :label="item.sysValue" :value="item.sysValue"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :xs="24" :md="12">
									<el-form-item :label="$t('projectName1')" prop="projectName">
										<el-input v-model="projectForm.projectName" :disabled="projectForm.editProjectName"/>
									</el-form-item>
								</el-col>
							</el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('upstreamSystemId1')" >
                    <el-input v-model="projectForm.upstreamSystemId" :disabled="projectForm.showEdit == '0'" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
								<el-col :xs="24" :md="12">
									<el-form-item :label="$t('ipmsProjectCode1')" >
										<el-input v-model="projectForm.ipmsProjectCode" :disabled="projectForm.showEdit == '0'" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
							</el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('projectManager1')" prop="projectManager" >
                    <el-select v-model="projectForm.projectManager" clearable filterable 
                        remote :remote-method="value => remoteMethod('ProjectManagerList', value)">
                      <el-option v-for="(item, index) in ProjectManagerList" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
                    </el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('deputyProjectManager1')">
                    <el-select v-model="projectForm.deputyProjectManager" clearable filterable remote :remote-method="value => remoteMethod('DeputyManagerList', value)">
                      <el-option v-for="(item, index) in DeputyManagerList" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
                    </el-select>
									</el-form-item>
								</el-col>
							</el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('department1')" prop="department">
                    <!-- <el-select v-model="projectForm.department" clearable filterable :filter-method="filterDept" 
                        v-el-select-loadmore="loadMore(rangeNumber)" @visible-change="visibleDept">
                      <el-option v-for="(item, index) in DepartmentList.slice(0, rangeNumber)" :key="index" :label="item.deptName" :value="item.deptCode"></el-option>
                    </el-select> -->
                    <el-select filterable v-model="projectForm.department" clearable>
											<el-option v-for="item in DeptList" :key="item.deptCode" :label="item.deptEnName" :value="item.deptCode"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('industry1')" prop="industry">
                    <el-select filterable v-model="projectForm.industry" clearable>
											<el-option v-for="item in IndustryList" :key="item.sysValue" :label="item.sysValue" :value="item.sysValue"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row>
								<el-col :xs="24" :md="12">
									<el-form-item :label="$t('projectStatus1')" prop="projectStatus" >
                    <el-select v-model="projectForm.projectStatus" clearable>
											<el-option v-for="item in StatusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
                  <el-form-item :label="$t('projectLevel1')" prop="projectLevel">
										<el-select filterable v-model="projectForm.projectLevel" clearable>
											<el-option v-for="item in ProjectLevelList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('projectStartDate1')" prop="projectStartDate">
										<el-date-picker v-model="projectForm.projectStartDate" :editable="true" :clearable="true" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" 
                      :placeholder="$t('selectdate')"></el-date-picker>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('projectEndDate1')" prop="projectEndDate">
										<el-date-picker v-model="projectForm.projectEndDate" disabled type="datetime" value-format="yyyy-MM-dd HH:mm:ss" 
                      :placeholder="$t('selectdate')"></el-date-picker>
									</el-form-item>
								</el-col>
              </el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('projectEstimatedEndDate1')" prop="projectEstimatedEndDate" >
										<el-date-picker v-model="projectForm.projectEstimatedEndDate" :editable="true" :clearable="true" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" 
                      :placeholder="$t('selectdate')"></el-date-picker>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('projectActualEndDate1')" prop="projectActualEndDate" >
										<el-date-picker v-model="projectForm.projectActualEndDate" :editable="true" :clearable="true" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" 
                      :placeholder="$t('selectdate')"></el-date-picker>
									</el-form-item>
								</el-col>
              </el-row>
							<el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('beneficialDept1')" prop="beneficialStrDept">
                    <!-- <el-select filterable v-model="projectForm.beneficialDept" :disabled="projectForm.showEdit == '0'" clearable @change="selectBeneficialDept">
											<el-option v-for="item in BeneficialDeptList" :key="item.deptCode" :label="item.deptName" :value="item.deptCode"></el-option>
										</el-select> -->
                    <el-cascader v-model="projectForm.beneficialStrDept" :options="BeneficialDeptList" :props="optionProps" :change-on-select="true" clearable></el-cascader>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('finalBeneficialDept1')" prop="finalBeneficialDept">
                    <!-- <el-select v-model="projectForm.finalBeneficialDept" clearable filterable :filter-method="filterFinalDept" 
                        v-el-select-loadmore="loadMore(rangeNumber)" @visible-change="visibleFinalDept">
                      <el-option v-for="(item, index) in FinalBeneficialDeptList.slice(0, rangeNumber)" :key="index" :label="item.deptName" :value="item.deptCode"></el-option>
                    </el-select> 
                    <el-select filterable v-model="projectForm.finalBeneficialDept" :disabled="projectForm.showEdit == '0'" clearable>
											<el-option v-for="item in FinalBeneficialDeptList" :key="item.deptCode" :label="item.deptName" :value="item.deptCode"></el-option>
										</el-select>-->
                    <el-input v-model="projectForm.finalBeneficialDept" disabled/>
									</el-form-item>
								</el-col>
							</el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('salesMan1')" >
										<el-input v-model="projectForm.salesMan" :disabled="projectForm.showEdit == '0'" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('salesRegion1')">
										<el-input v-model="projectForm.salesRegion" :disabled="projectForm.showEdit == '0'" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('presaleKeyProject1')" prop="presaleKeyProject" >
                    <el-select v-model="projectForm.presaleKeyProject" clearable>
											<el-option v-for="item in PresaleKeyProjectList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('postsaleKeyProject1')" >
                    <el-select v-model="projectForm.postsaleKeyProject" :disabled="projectForm.showEdit == '0'" filterable clearable>
											<el-option v-for="item in PostsaleKeyProjectList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
							</el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('beltAndRoad1')" prop="beltAndRoad" >
                    <el-select v-model="projectForm.beltAndRoad" clearable>
											<el-option v-for="item in BeltAndRoadList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('subcontractor1')" >
										<el-input v-model="projectForm.subcontractor" :disabled="projectForm.showEdit == '0'" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
							</el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('businessType1')" >
                    <el-select filterable v-model="projectForm.businessType" :disabled="projectForm.showEdit == '0'" clearable>
											<el-option v-for="item in BusinessTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('deliveryType1')" >
                    <el-select filterable v-model="projectForm.deliveryType" :disabled="projectForm.showEdit == '0'" clearable>
											<el-option v-for="item in DeliveryTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
              </el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('remark1')">
										<el-input v-model="projectForm.remark" :disabled="projectForm.showEdit == '0'" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
							</el-row>
            </el-card>
          </el-form>
				</el-col>
			</el-row>
		</el-tab-pane>
    <el-tab-pane name="second" :label="$t('customerInfo')">
      <el-row>
				<el-col :xs="24">
          <el-form :model="customerForm" :rules="rules" ref="customerForm" label-width="200px">
					  <el-card >
							<el-row>
								<el-col :xs="24" :md="12">
									<el-form-item :label="$t('customerName1')" prop="customerName">
                    <el-select v-model="customerForm.customerName" clearable filterable remote :remote-method="value => remoteMethodCustomer('CustomerList', value)" @change="selectCustomer">
											<el-option v-for="(item) in CustomerList" :key="item.csiAccountCode" :label="item.customerName" :value="item.customerName"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('csiAccountCode1')" prop="csiAccountCode">
										<el-input v-model="customerForm.csiAccountCode" :disabled="projectForm.showEdit == '0'" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
							</el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('customerIndustry1')" prop="customerIndustry">
                    <el-select filterable v-model="customerForm.customerIndustry" :disabled="projectForm.showEdit == '0'" clearable>
											<el-option v-for="item in IndustryList" :key="item.sysValue" :label="item.sysValue" :value="item.sysValue"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('subIndustry1')" >
                    <el-input v-model="customerForm.subIndustry" :disabled="projectForm.showEdit == '0'" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row>
								<el-col :xs="24" :md="12">
									<el-form-item :label="$t('customerType1')" prop="customerType">
                    <el-select filterable v-model="customerForm.customerType" :disabled="projectForm.showEdit == '0'" clearable>
											<el-option v-for="item in CustomerTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('customerContact1')" >
										<el-input v-model="customerForm.customerContact" :disabled="projectForm.showEdit == '0'" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('customerMobile1')">
										<el-input v-model="customerForm.customerMobile" :disabled="projectForm.showEdit == '0'" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('customerAddress1')">
										<el-input v-model="customerForm.customerAddress" :disabled="projectForm.showEdit == '0'" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
              </el-row>
            </el-card>
          </el-form>
				</el-col>
			</el-row>
    </el-tab-pane>
    <el-tab-pane name="third" :label="$t('contractInfo')">
      <el-row>
				<el-col :xs="24">
          <el-form :model="contractForm" :rules="rules" ref="contractForm" label-width="210px">
					  <el-card >
							<el-row>
								<el-col :xs="24" :md="12">
									<el-form-item :label="$t('serviceContractNo1')" prop="serviceContractNo">
										<el-input v-model="contractForm.serviceContractNo" :disabled="editServiceContractNo" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('contactVersionNo1')" >
										<el-input v-model="contractForm.contactVersionNo" disabled clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
							</el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('serviceSalesModule1')" >
                    <el-select filterable v-model="contractForm.serviceSalesModule" :disabled="projectForm.showEdit == '0'" clearable>
											<el-option v-for="item in ServiceSalesModuleList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('serviceSalesType1')" >
                    <el-select filterable v-model="contractForm.serviceSalesType" :disabled="projectForm.showEdit == '0'" clearable>
											<el-option v-for="item in ServiceSalesTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
              </el-row>
              <el-row>
                <el-col :xs="24" :md="12">
                  <el-form-item :label="$t('maintenanceStartDate1')">
										<el-date-picker v-model="contractForm.maintenanceStartDate" :disabled="projectForm.showEdit == '0'" :editable="true" :clearable="true" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" 
                      :placeholder="$t('selectdate')"></el-date-picker>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
                  <el-form-item :label="$t('maintenanceEndDate1')">
										<el-date-picker v-model="contractForm.maintenanceEndDate" :disabled="projectForm.showEdit == '0'" :editable="true" :clearable="true" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" 
                      :placeholder="$t('selectdate')"></el-date-picker>
									</el-form-item>
								</el-col>
              </el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('maintenanceContent1')" >
                    <el-input v-model="contractForm.maintenanceContent" :disabled="projectForm.showEdit == '0'" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('amountExdudingTax1')" >
										<el-input v-model="contractForm.amountExdudingTax" :disabled="projectForm.showEdit == '0'" clearable :placeholder="$t('enter')" oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d*).*$/, '$1$2.$3').replace(/^\./g, '')"/>
									</el-form-item>
								</el-col>
              </el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('currency1')" prop="currency">
                    <el-select filterable v-model="contractForm.currency" clearable>
											<el-option v-for="item in CurrencyList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
              </el-row>
            </el-card>
          </el-form>
				</el-col>
			</el-row>
    </el-tab-pane>
    <el-row>
      <el-col style="margin-top: 10px; text-align: center;" :xs="24" :md="24">
        <el-button type="primary" @click="submitForm('projectForm')">{{$t('save')}}</el-button>
        <el-button type="primary" size="medium" @click="returnList">{{$t('return')}}</el-button>
      </el-col>
    </el-row>
	</el-tabs>
</template>
<script>
    import {_debounce} from '@/utils/selectAPI'
    import * as validate from '@/utils/validate'
    export default {
        created () {
          this.getCountry();
          this.getDeptSelect();
          this.getProjectTypeList();
          this.getBusinessCategoryList();
          this.getBeneficialDeptList();
          this.getIndustryList();
          this.getProjectData();
        },
        data () {
          var setDeptValue = (rule, value, callback) => {
            let userInfo = this.ProjectManagerList.find(item => {
              return item.empCode === value;
            });
            if(userInfo != null){
              this.projectForm.department = userInfo.deptCode;
            }
            callback();
          };
          var checkDate = (rule, value, callback) => {
            if(this.projectForm.projectStartDate != null && this.projectForm.projectEndDate !=  null){
              if(this.projectForm.projectStartDate >= this.projectForm.projectEndDate ){
                return callback(new Error('The end date must be later than start date'));
              }
            }
            callback();
          };
          var checkEstimatedDate  = (rule, value, callback) => {
            if(this.projectForm.projectStartDate != null){
              if(this.projectForm.projectStartDate >= this.projectForm.projectEstimatedEndDate ){
                return callback(new Error('The estimated end date must be later than start date'));
              }
            }
            this.projectForm.projectEndDate = value;
            callback();
          };
          var checkActualDate  = (rule, value, callback) => {
            if(this.projectForm.projectStartDate != null){
              if(this.projectForm.projectStartDate >= this.projectForm.projectActualEndDate ){
                return callback(new Error('The actual end date must be later than start date'));
              }
            }
            callback();
          };
          var checkCustomerName  = (rule, value, callback) => {
            if(this.projectForm.projectType == "SSF" || this.projectForm.projectType == "CDMPD" || this.projectForm.projectType == "CDSPD"){
              if(value == null || value == "" ){
                return callback(new Error('Please select Account'));
              }
            }
            callback();
          };
          var getDeptName  = (rule, value, callback) => {
            if(this.submitG){
              this.projectForm.beneficialDept = value.join(",");
              //查询最终受益部门
              let deptCode = value[value.length-1];
              let url =`${this.$store.state.islhurl}dept/getDeptName`;
              let pm = {
                deptCode: deptCode,
              }
              this._post(url,pm).then(
                res => {
                  this.projectForm.finalBeneficialDept = res.deptName;
                }
              )
            }
            callback();
          };
          var checkServiceContractNo = (rule, value, callback) => {
            if(value != null && value != ""){
              let params = {
                serviceContractNo : value,
                id: this.contractForm.id
              }
              let url =`${this.$store.state.islhurl}project/getContractInfo`
              this._post(url,params).then(
                res => {      
                  if(res == '1'){
                    return callback(new Error('The ServiceContractNo already exists'));
                  }else{
                    callback();
                  }
                }
              )
            }else{
              callback();
            }
          };
          var checkCurrency = (rule, value, callback) => {
            if(this.projectForm.projectType == 'CDC' && (value == null || value == "")){
              return callback(new Error('Please select data'));
            }else{
              callback();
            }
          };
          let that = this;
          return {
            rangeNumber: 10,
            projectForm: {
              projectName:null,
              projectStatus:null,
              businessCategory:null,
              projectType:null,
              upstreamSystemId:null,
              ipmsProjectCode:null,
              projectManager:null,
              deputyProjectManager:null,
              department:null,
              industry:null,
              country:null,
              deliveryType:null,
              projectLevel:null,
              projectStartDate:null,
              projectEndDate:null,
              projectEstimatedEndDate:null,
              projectActualEndDate:null,
              beneficialDept:null,
              beneficialStrDept:[],
              finalBeneficialDept:null,
              salesMan:null,
              salesRegion:null,
              presaleKeyProject:null,
              postsaleKeyProject:null,
              beltAndRoad:null,
              businessType:null,
              subcontractor:null,
              remark:null,
              projectSource:null
            },
            customerForm: {
              customerName:null,
              csiAccountCode:null,
              customerIndustry:null,
              subIndustry:null,
              customerType:null,
              customerContact:null,
              customerMobile:null,
              customerAddress:null,
            },
            contractForm: {
              serviceContractNo:null,
              productContractNo:null,
              purchaseOrderNo:null,
              salesOrderNo:null,
              reseller:null,
              distributor:null,
              serviceSalesModule:'N/A',
              serviceSalesType:'N/A',
              firstShipmentDate:null,
              estimatedServiceStartDate:null,
              serviceDuration:null,
              maintenanceStartCondition:null,
              maintenanceStartDate:null,
              maintenanceContent:null,
              amountExdudingTax:null,
              amountWithTax:null,
              listPrice:null,
              attachServiceId:null,
              ibServiceId:null,
              orderStatus:null,
              contactVersionNo:null,
              bomCode:null,
              bomName:null,
              currency:null
            },
            submitG:true,
            editCountry:true,
            editProjectName:false,
            editServiceContractNo:false,
            CustomerList:[],
            ProjectTypeList:[],
            BusinessCategoryList:[],
            ProjectManagerList:[],
            DeptList:[],
            DeputyManagerList:[],
            DepartmentList:[],
            IndustryList:[],
            DeliveryTypeList:[
              { value: 'DirectService',label: 'DirectService'},
              { value: 'Outsource',label: 'Outsource'},
            ],
            ProjectLevelList:[
              { value: 'Normal',label: 'Normal'},
              { value: 'Department',label: 'Department'},
              { value: 'Corp',label: 'Corp'},
            ],
            BeneficialDeptList:[],
            FinalBeneficialDeptList:[],
            CountryList:[],
            BeltAndRoadList:[
              { value: 'Yes',label: 'Yes'},
              { value: 'No',label: 'No'},
            ],
            CustomerTypeList:[
              { value: 'ordinary',label: '普通客户'},
              { value: 'value',label: '价值客户'},
              { value: 'OEM',label: 'OEM客户'},
              { value: 'Agent',label: 'Agent'},
            ],
            StatusList:[
              { value: 'ToDelivered',label: 'Waiting for Delivery'},
              { value: 'Delivered',label: 'Delivering'},
              { value: 'PartialDelivery',label: 'Partially delivered'},
              { value: 'DeliveryCompleted',label: 'Fully Delivered'},
            ],
            PresaleKeyProjectList:[
              { value: 'Yes',label: 'Yes'},
              { value: 'No',label: 'No'},
            ],
            PostsaleKeyProjectList:[
              { value: 'Normal',label: 'Normal'},
              { value: 'Department',label: 'Department'},
              { value: 'Corp',label: 'Corp'},
            ],
            BusinessTypeList:[
              { value: 'BR',label: 'BR'},
              { value: 'RO',label: 'RO'},
              { value: 'NEC',label: 'NEC'},
              { value: 'SBR',label: 'SBR'},
              { value: 'SRO',label: 'SRO'},
              { value: 'SNEC',label: 'SNEC'},
            ],
            ServiceSalesModuleList:[
              { value: 'N/A',label: 'N/A'},
              { value: '直签',label: '直签'},
              { value: '代理商转售',label: '代理商转售'},
              { value: '代理商销售',label: '代理商销售'},
              { value: '代理商直签',label: '代理商直签'},
              { value: '商业分销',label: '商业分销'},
              { value: '直签销售',label: '直签销售'},
            ],
            CurrencyList:[
              { value: 'USD',label: 'USD'},
              { value: 'CNY',label: 'CNY'}
            ],
            ServiceSalesTypeList:[
              { value: 'N/A',label: 'N/A'},
              { value: '单独销售',label: '单独销售'},
              { value: '随项目销售',label: '随项目销售'},
            ],
            optionProps:{
              value:'deptCode',
              label:'deptEnName',
              children:[],
              lazy:true,
              lazyLoad(node, resolve){
                if(node.level > 0){
                  let url =`${that.$store.state.islhurl}dept/getDeptList`;
                  let pm = {
                    supDeptCode: node.value,
                  }
                  that._post(url,pm).then(
                    res => {
                      // leaf:node.level >= 2
                      const nodes = res.data.map(item => ({
                        deptCode:item.deptCode,
                        deptEnName:item.deptEnName,
                      }))
                      resolve(nodes)
                    }
                  )
                }
              }
            },
            rules: {
              projectName: [
                { required: true, message:'Please input value', trigger: 'blur' },
              ],
              projectStatus: [
                { required: true, message:'Please input value', trigger: 'blur' },
              ],
              projectType: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              businessCategory: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              projectManager: [
                { required: true, message: 'Please input value', trigger: 'blur' },
                { validator:setDeptValue,trigger: 'change'}
              ],
              department: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              industry: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              projectLevel: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              projectStartDate: [
                { required: true, message:'Please select date', trigger: 'change' },
                { validator: checkDate, trigger: 'change'}
              ],
              projectEndDate: [
                { required: true, message:'Please select date', trigger: 'change' },
                { validator: checkDate, trigger: 'change'}
              ],
              projectEstimatedEndDate: [
                { required: true, message:'Please select date', trigger: 'change' },
                { validator: checkEstimatedDate, trigger: 'change'}
              ],
              projectActualEndDate: [
                { validator: checkActualDate, trigger: 'change'}
              ],
              beneficialStrDept: [
                { required: true, message:'Please select data', trigger: 'change' },
                { validator: getDeptName, trigger: 'change'}
              ],
              finalBeneficialDept: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              presaleKeyProject: [
                { required: true, message: 'Please input value', trigger: 'blur' },
              ],
              postsaleKeyProject: [
                { required: true, message:'Please input value', trigger: 'blur' },
              ],
              country: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              beltAndRoad: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              customerName: [
                { validator: checkCustomerName, trigger: 'change'}
              ],
              serviceContractNo: [
                { validator: checkServiceContractNo, trigger: 'blur'},
              ],
              currency: [
                { validator: checkCurrency, trigger: 'change' }
              ],
            }
          }
        },
        methods: {
          remoteMethod(list, query) {
            if (query !== '') {
              // 清除之前的定时器
              if (this.timeout) {
                clearTimeout(this.timeout)
              }
              // 防抖处理，300ms后执行
              this.timeout = setTimeout(() => {
                this.fetchUserOptions(list, query)
              }, 200)
            } else {
              this[list] = []
            }
          },
          fetchUserOptions(list, query) {
            let url =`${this.$store.state.islhurl}user/select-option?keyword=${query}`;
            this._get(url).then().then(res => {
              if(res.code === 200 && res.data) {
                this[list] = res.data;
              } else {
                this[list] = [];
              }
            }).catch(error => {
              this[list] = [];
              console.error('搜索失败:', error)
            })
          },
          getDeptSelect(){
            let url =`${this.$store.state.islhurl}dept/getSelectData`;
            let pm = {
              deptCodechain: 'SelectDept',
            }
            this._post(url,pm).then(
              res => {   
                this.DeptList = res.data;
              }
            )
          },
          getBeneficialDeptList(){
            let url =`${this.$store.state.islhurl}dept/getSelectData`;
            let pm = {
              deptLevel: '1',
            }
            this._post(url,pm).then(
              res => {   
                this.BeneficialDeptList = res.data;
              }
            )
          },
          getCountry(){
            let url =`${this.$store.state.islhurl}keyValue/getSelectData`;
            let pm = {
              sysKey: 'Country',
            }
            this._post(url,pm).then(
              res => {   
                this.CountryList = res.data;
              }
            )
          },
          getBusinessCategoryList(){
            let url =`${this.$store.state.islhurl}keyValue/getSelectData`;
            let pm = {
              sysKey: 'BusinessCategory',
            }
            this._post(url,pm).then(
              res => {   
                this.BusinessCategoryList = res.data;
              }
            )
          },
          getProjectTypeList(){
            let url =`${this.$store.state.islhurl}keyValue/getSelectData`;
            let pm = {
              sysKey: 'ProjectType',
            }
            this._post(url,pm).then(
              res => {   
                this.ProjectTypeList = res.data;
              }
            )
          },
          getIndustryList(){
            let url =`${this.$store.state.islhurl}keyValue/getSelectData`;
            let pm = {
              sysKey: 'Industry',
            }
            this._post(url,pm).then(
              res => {   
                this.IndustryList = res.data;
              }
            )
          },
          selectCustomer(customerName){
            let customer = this.CustomerList.find(item => {
              return item.customerName === customerName;
            })
            if(customer != null){
              this.customerForm.csiAccountCode = customer.csiAccountCode;
              this.customerForm.customerIndustry = customer.customerIndustry;
              this.customerForm.subIndustry = customer.subIndustry;
              this.customerForm.customerType = customer.customerType;
              this.customerForm.customerContact = customer.customerContact;
              this.customerForm.customerMobile = customer.customerMobile;
              this.customerForm.customerAddress = customer.customerAddress;
            }
          },
          // selectBeneficialDept(beneficialDept){//暂不用
          //   let url =`${this.$store.state.islhurl}dept/getFinalDeptList`;
          //   let pm = {
          //     deptCode: beneficialDept,
          //   }
          //   this._post(url,pm).then(
          //     res => {   
          //       this.FinalBeneficialDeptList = res.data;
          //     }
          //   )
          // },
          selectBusinessCategory(businessCategory){
            let url =`${this.$store.state.islhurl}keyValue/getSelectData`;
            let pm = {
              sysKey: 'ProjectType',
              remark: businessCategory,
            }
            this._post(url,pm).then(
              res => {   
                this.ProjectTypeList = res.data;
              }
            )
          },
          //回显数据
          getProjectData(){
            let url = `${this.$store.state.islhurl}project/getInfo`
            let pm = {
              id: this.$route.params.id,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this._post(url,pm).then(
              res =>{
                //先加载下拉选项
                setTimeout(() => {
                  const validValues = [
                    res.project.projectManager,
                    res.project.deputyProjectManager,
                  ].filter(value => value != null && value !== "");
                  if (validValues && validValues.length > 0) {
                    this.getUserList(validValues);
                  }
                }, 1500);
                //再进行赋值
                this.projectForm = res.project;
                if(res.project.beneficialDept != null){
                  let dept = res.project.beneficialDept.split(",")[0];
                  let arr = [];
                  arr.push(dept);
                  this.projectForm.beneficialStrDept = arr;
                }
                if(res.project.projectType == 'WDC' && res.project.beltAndRoad == 'Yes'){
                  this.editCountry = false;
                }else{
                  this.editCountry = true;
                }
                if(res.customer != null){
                  this.customerForm = res.customer;
                }
                if(res.contract != null){
                  this.contractForm = res.contract;
                }
                this.judgeManual();
                this.setEitProjectName();
              }
            )
          },
          getUserList(validValues) {
            let url =`${this.$store.state.islhurl}user/batch-get`;
            let obj = {
              empCodeList: validValues
            }
            this._post(url, obj).then(
              res => {  
                if(res.code === 200 && res.data) {
                  this.ProjectManagerList = res.data
                  this.DeputyManagerList = res.data
                }
              }
            )
          },
          submitForm(formName) {
            this.submitG = false;
            this.$refs[formName].validate((pvalid) => {
              if (pvalid) {
                this.$refs['customerForm'].validate((cvalid) => {
                  if (cvalid) {
                    this.$refs['contractForm'].validate((convalid) => {
                      if (convalid) {
                        // console.log('success submit')
                        this.editInfo();
                      } else {
                        this.$message({type:'error', showClose:true, duration:5000, message:'Please fill in the contract info'});
                        return false;
                      }
                    });
                  } else {
                    this.$message({type:'error', showClose:true, duration:5000, message:'Please fill in the account info'});
                    this.submitG = true;
                    return false;
                  }
                });
              } else {
                console.log('error submit!!');
                this.submitG = true;
                return false;
              } 
            });
          },
          editInfo(){
            let params = {
              projectId:this.$route.params.id,
              project:this.projectForm,
              customer:this.customerForm,
              contract:this.contractForm,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            // console.log(params);
            let url = `${this.$store.state.islhurl}project/editInfo`
            this._post(url,params).then(
              res => {
                if(res=="200"){
                  // this.$router.push({path:'/project/list'})
                  this.$router.push({ name: 'project', params: { refresh: 1 } })
                  this.$Message.success('Save successful' )
                }else{
                  this.$message.error(res);
                }
              }
            )
          },
          stringToArray(val){
            var result = new Array();
            if(val != null && val != ""){
              var array = val.split(",");
              for(var i =0 ;i<array.length;i++){
                result.push(array[i]);
              }
            }
            return result;
          },
          returnList(){
            let pm = this.$route.params;
            this.$router.push({name:'project',params:pm});
          },
          loadMore(n) {
            // n是默认初始展示的条数会在渲染的时候就可以获取,具体可以打log查看
            // elementui下拉超过7条才会出滚动条,如果初始不出滚动条无法触发loadMore方法
            return () => (this.rangeNumber += 5); // 每次滚动到底部可以新增条数,可自定义
          },
          
          remoteMethodCustomer(list, query) {
            if (query !== '') {
              // 清除之前的定时器
              if (this.timeout) {
                clearTimeout(this.timeout)
              }
              // 防抖处理，300ms后执行
              this.timeout = setTimeout(() => {
                this.fetchCusOptions(list, query)
              }, 200)
            } else {
              this[list] = [];
            }
          },
          fetchCusOptions(list, query) {
            let url =`${this.$store.state.islhurl}project/customer-option?keyword=${query}`;
            this._get(url).then().then(res => {
              if(res.code === 200 && res.data) {
                this[list] = res.data;
              } else {
                this[list] = [];
              }
            }).catch(error => {
              this[list] = [];
              console.error('搜索失败:', error)
            })
          },
          judgeManual(){
            if(this.projectForm.projectSource=='手工'){
              this.projectForm.editProjectName=false;
            }else{
              this.projectForm.editProjectName=true;
            }
          },
          setEitProjectName(){
            if(this.projectForm.projectType == 'CDC'){
              this.editServiceContractNo = true;
            }else{
              this.editServiceContractNo = false;
            }
          }
        },
        directives:{
          'el-select-loadmore':(el, binding) => {
            // 获取element-ui定义好的scroll盒子
            const SELECTWRAP_DOM = el.querySelector(".el-select-dropdown .el-select-dropdown__wrap");
            if(SELECTWRAP_DOM){
              //解除绑定事件
              el.unbindEventListener = () => {
                SELECTWRAP_DOM.removeEventListener("scroll", function () {
                  const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
                  if (condition) binding.value();
                });
              }
              //绑定事件
              SELECTWRAP_DOM.addEventListener("scroll", function () {
                /**
                 * scrollHeight 获取元素内容高度(只读)
                 * scrollTop 获取或者设置元素的偏移值,
                 *  常用于:计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
                 * clientHeight 读取元素的可见高度(只读)
                 * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
                 * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
                 */
                const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
                if (condition) binding.value();
              });
            }
          },
        }
    }
</script>


// WEBPACK FOOTER //
// src/view/project/projectEdit.vue